import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import productPricingSelector from 'yoda-site-components/lib/selectors/ProductPricingSelector';
import selectProductType from 'yoda-site-components/lib/selectors/productDetails/selectProductType';
import ImageBanner from 'yoda-site-components/lib/components/CMImageBanner/ImageBanner';
import triggerPLCCAnalytics from 'yoda-site-components/lib/helpers/Utils/plccHelper';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import getCMCreditCardBannerData from '../../actions/CMCreditCardBannerAction';
import { creditCardBannerConst } from '../../helpers/ProductConstants';
import * as styles from '../ProductInfo/ProductInfo.css';

const cx = classNames.bind(styles);

const CreditCardBanner = (props) => {
    const { cmCreditCardBannerData = {} } = useSelector((store) => store);
    const {
        analyticsAction: { plccApplyAnalytics },
        CMFallback,
    } = props;
    let isDataThere = false;
    const pricingDetails = useSelector((state) => productPricingSelector(false)(state));
    const productType = useSelector((state) => selectProductType(false)(state));
    const pictureVariantsData = cmCreditCardBannerData?.content?.grid?.placements[0]?.items[0];
    isDataThere = !isEmpty(cmCreditCardBannerData?.content?.grid);
    const creditCardLink = isDataThere ? pictureVariantsData?.urlHolder?.value : '';
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(
            getCMCreditCardBannerData({ searchTerm: creditCardBannerConst.CREDIT_CARD_BANNER_TYPE })
        );
    }, []);
    useEffect(() => {
        triggerPLCCAnalytics(plccApplyAnalytics, {
            plccBanner: 'static_PDP_apply',
            href: creditCardLink,
        });
        CMFallback(cmCreditCardBannerData?.isError);
    }, [isDataThere, cmCreditCardBannerData]);
    let showBanner = false;
    const price = pricingDetails.defaults || pricingDetails.original;
    if (typeof price === 'string') {
        showBanner =
            price.replace(/\$/, '').replace(/,/g, '') >
                creditCardBannerConst.creditCardBannerPriceThreshold &&
            isDataThere &&
            !cmCreditCardBannerData?.isError;
    } else if (productType && productType.templateType === 'bundle') {
        showBanner = !isEmpty(cmCreditCardBannerData?.content?.grid);
    }
    if (showBanner) {
        return (
            <div
                className={`${cx('sm12', 'md12', 'lg12', 'xl12', 'creditcardBanner')} ${dt([
                    'sm:!px-0',
                    'pb-10',
                ])}`}
            >
                <ImageBanner dataPlccName="static_PDP_apply" data={pictureVariantsData} />
            </div>
        );
    }
    return null;
};

export default CreditCardBanner;
